import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getJsonValue',
  standalone: false
})
export class GetJsonValuePipe implements PipeTransform {

  // transform(value: unknown, ...args: unknown[]): unknown {
  //   return null;
  // }

  transform(json: any, find: string): string {
    const splitValues = find.split('.');
    // console.log(splitValues);
    let text: any = json;
    splitValues.forEach((value, index) => {
      // text = text === null ? '-' : text[value] !== null ? text[value] : '-';
      text = text === null ? '-' : text[value] !== null && text[value] !== undefined ? text[value] : '-';
      // console.log(text);
    });
    return text;
  }

}
